/**
 * this annotation allows the function it decorates to perform a change in the URL search parameters without
 * causing a state reload.
 * Note that in order to support the back and forward buttons in the browser we must leave
 * the 'reloadOnSearch' parameter of the state as true and therefore changing the url search params without
 * this annotation will result in a state reload.
 */
var angular:angular.IAngularStatic =  require('angular');
export function preventStateReload(target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>){

            let originalMethod = descriptor.value;
            descriptor.value = function(...args: any[]) {

               //pre
                    let $state=angular.element(document.getElementsByTagName('primo-explore')).injector().get('$state');
                	$state.current.reloadOnSearch= false; //set the reloadOnSearch to false so that state isn't reloaded

                let result = originalMethod.apply(this, args); // run and store the result

                //post
                    /*listen for locationChangeSuccess and change reloadOnSearch back to true so that we once again
                    support back and forward buttons in browser */
                    let listener=angular.element(document.getElementsByTagName('primo-explore')).injector().get('$rootScope').$on('$locationChangeSuccess',()=>{
                        $state.current.reloadOnSearch= true;
                        listener();
                    });

                return result; // return the result of the original method
            };
        return descriptor;
	}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/annotations.ts